import { render, staticRenderFns } from "./EditorProxy.vue?vue&type=template&id=124e0f58"
import script from "./EditorProxy.vue?vue&type=script&lang=ts"
export * from "./EditorProxy.vue?vue&type=script&lang=ts"
import style0 from "./EditorProxy.vue?vue&type=style&index=0&id=124e0f58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports